import { defa }          from 'defa-object';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.DigiHeat
 * The DEFA FollowMainAlarm model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	homeautomation: '/homeAutomation/diyWirelessDevices?attrs=',
};

const DigiHeat = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.homeautomation + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			digiHeatMode: 'NO_DIGIHEAT',
			digiHeatModeError: null,
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			if(response.digiHeatMode){
				this.parseAttribute('digiHeatMode', response.digiHeatMode, options, newModelAttributes);
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'digiHeatModes' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON: function() {
		return { digiHeatMode: this.get('digiHeatMode') };
	},
	
	getAttributes: function() {
		return 'digiHeatMode';
	},
	
} );

export default DigiHeat;
